import axiosInstance from '../axios';
import { API_ROUTES } from '../../enums/API_ROUTES';
import { COMMENT_PARENT_TYPE } from '../../enums/ENUMS';
import type { COMMENT } from '../../enums/TYPES';
import type { VIDEOFEED } from '../../enums/TYPES';
import type { VideoDrawingData } from '../../components/VideoDrawing/types';
import type { CacheRequestConfig } from 'axios-cache-interceptor';

const drawingMarkerRequestConfig: CacheRequestConfig = { cache: false };

export const createDrawingMarker = (data: {
  message: string; videofeedId: string; clipId?: string; timestamp: number; drawing: VideoDrawingData;
}) => axiosInstance.post<COMMENT>(`${API_ROUTES.COMMENT}/drawing-marker`, data);

export const updateDrawingMarker = (id: string, data: { drawing?: VideoDrawingData; message?: string }) =>
  axiosInstance.patch<COMMENT>(`${API_ROUTES.COMMENT}/drawing-marker/${id}`, data);

export const sendCommentToComposer = (commentId: string, data: {
  destinationId?: string; title?: string; videoId?: string;
  inSeconds: number; outSeconds: number; addOnBottom?: boolean; clientOperationId?: string;
}) => axiosInstance.post<VIDEOFEED>(`${API_ROUTES.COMMENT}/${commentId}/send-to-composer`, data);

export const getDrawingMarkers = (videofeedId: string) =>
  axiosInstance.get<COMMENT[]>(`${API_ROUTES.COMMENT}/drawing-markers/${videofeedId}`, drawingMarkerRequestConfig);

export const getVideoCommentMarkers = (videofeedId: string) =>
  axiosInstance.get<COMMENT[]>(`${API_ROUTES.COMMENT}/video-comment-markers/${videofeedId}`, drawingMarkerRequestConfig);

export const createNewComment = async (data: {
  message: string;
  parentId: string;
  parentType: COMMENT_PARENT_TYPE;
  timestamp?: number;
}) => {
  const res = await axiosInstance.post(API_ROUTES.COMMENT, data);

  return res;
};

export const updateComment = async (
  id: string,
  data: {
    newMessage: string;
  },
) => {
  const res = await axiosInstance.patch(`${API_ROUTES.COMMENT}/${id}`, data);

  return res;
};

export const deleteComment = async (id: string, videofeedId: string) => {
  const res = await axiosInstance.delete(`${API_ROUTES.COMMENT}/${id}/${videofeedId}`);

  return res;
};

export const searchUsersAndGroups = async (videofeedId: string, search: string) => {
  return await axiosInstance.get(`${API_ROUTES.COMMENT_SEARCH_TAGS}?videofeedId=${videofeedId}&search=${search}`);
};
